// src/lib/player-analytics.ts
// Analytics are emitted ONLY from the player store (never from components).
export type PlayerEventName =
  | "play"
  | "pause"
  | "seek"
  | "complete"
  | "heartbeat";

export function track(
  event: PlayerEventName,
  assetId: string,
  position: number,
  extra?: Record<string, unknown>,
): void {
  if (typeof window === "undefined") return;
  const body = JSON.stringify({
    event,
    assetId,
    position: Math.round(position),
    ts: Date.now(),
    ...extra,
  });
  try {
    if (navigator.sendBeacon) {
      navigator.sendBeacon(
        "/api/analytics",
        new Blob([body], { type: "application/json" }),
      );
    } else {
      void fetch("/api/analytics", {
        method: "POST",
        body,
        keepalive: true,
        headers: { "content-type": "application/json" },
      });
    }
  } catch {
    /* analytics must never break playback */
  }
}
